import React, { Component } from 'react';
// import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../../../actions/ModalActions';
import { migrateWeddingAccount, createEventAndMigrate } from '../../../../actions/EventActions';
import fetchDashboard from '../../../../actions/DashboardActions';
import EventsDropdown from './EventsDropdown';
import EventFormContainer from '../../../manage/common/EventFormContainer';
import { setCookie } from '../../../../util/storage';
// import { Link } from 'react-router';
// import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';

import eventsDoodle from '../../../../assets/images/doodles/events_doodle.png';
import './MultipleEventsMigrationModal.less';


class MultipleEventsMigrationModal extends Component {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleCreateEventOverride = this.toggleCreateEventOverride.bind(this);

    this.state = {
      selectedId: null,
      createEventOverride: false
    };
  }

  handleSelect(id) {
    this.setState({
      selectedId: id
    });
  }

  handleSubmit() {
    const { onMigrateWeddingAccount } = this.props;
    const { selectedId } = this.state;
    // console.log(selectedId);
    onMigrateWeddingAccount(selectedId);
  }

  toggleCreateEventOverride() {
    this.setState(prevState => ({
      createEventOverride: !prevState.createEventOverride
    }));
  }

  render() {
    const { migrationEvents, onSubmitOverride } = this.props;
    const { selectedId, createEventOverride } = this.state;

    if (migrationEvents.busy) {
      return null;
    }
    // add case for !migrationEvents.busy && migrationEvents.orderedIds.length === 0

    const options = migrationEvents.orderedIds.reduce((result, eventId) => {
      result.orderedIds.push(eventId);
      const { id, name } = migrationEvents.byId[eventId];
      result.byId[id] = { value: id, label: name }; // eslint-disable-line
      return result;
    }, { orderedIds: [], byId: {} });
    // console.log(options);

    return (
      <div className="multiple-events-migration-modal">
        <div className="modal-section">
          <div className="header-img-container">
            <img className="header-img" src={eventsDoodle} alt="Welcome to multiple events" />
          </div>
          <div>
            <h2 className="primary-header">Now Guests Can RSVP to Multiple Events</h2>
          </div>
          <div className="modal-section-dek">
            <p>
              Build guest lists for your shower, your wedding, your morning-after brunch,
              and everything in between. Then, customize privacy settings and online RSVPs,
              and track it all.{migrationEvents.orderedIds.length === 0 ? ' Create your first event to get started.' : ''}
            </p>
          </div>
          {(createEventOverride || migrationEvents.orderedIds.length === 0) && (
            <div className="modal-section-dek warning">
              <p>
                In order for your RSVPs to be saved, you MUST create an event to continue.
                We suggest just adding something general like &quot;Our Wedding.&quot;
                You can change the event name and details later.
              </p>
            </div>
          )}
          {(!createEventOverride && migrationEvents.orderedIds.length !== 0) && (
            <div className="modal-section-dek warning">
              <p>
                In order for you to continue, you MUST assign your RSVPs to an event.<br />
                Choose from the events you&#39;ve added.<br />
                You can change the event name and details later.
              </p>
            </div>
          )}
          {(!createEventOverride && migrationEvents.orderedIds.length !== 0) && (
            <div className="select-event">
              <div>
                <EventsDropdown options={options} onSelect={this.handleSelect} />
              </div>
              {(!selectedId || migrationEvents.migratingWeddingAccount) ? (
                <button className="btn btn-disabled btn-wide disabled" disabled>Connect RSVPs</button>
              ) : (
                <button className="btn btn-primary btn-wide" onClick={this.handleSubmit}>Connect RSVPs</button>
              )}
              <div className="toggle-button-container">
                <a role="button" className="text-button" onClick={this.toggleCreateEventOverride}>Or Create A New Event &rsaquo;</a>
              </div>
              <div className="help-section">
                <div className="faq-link">
                  {(!createEventOverride && migrationEvents.orderedIds.length !== 0) ? (
                    <p>Not sure what to do? <a href="https://help.zola.com/hc/en-us/articles/360002649351-I-m-being-forced-to-pick-an-event-for-my-RSVP-s-Help-" target="_blank" rel="noreferrer noopener" className="text-button">Learn More &rsaquo;</a></p>
                  ) : (
                    <p>Not sure what to do? <a href="https://help.zola.com/hc/en-us/articles/360002649491-Why-an-I-being-forced-to-create-an-event-" target="_blank" rel="noreferrer noopener" className="text-button">Learn More &rsaquo;</a></p>
                  )}
                </div>
                <div className="help-text">
                  <p>Need our help? Email <a href="mailto:support@zola.com">support@zola.com</a> or call us at 408-657-ZOLA.</p>
                </div>
              </div>
            </div>
          )}
        </div>
        {(createEventOverride || migrationEvents.orderedIds.length === 0) && (
          <div>
            {createEventOverride && (
              <div className="back-button-container">
                <a role="button" className="text-button" onClick={this.toggleCreateEventOverride}>&lsaquo; Back</a>
              </div>
            )}
            <div className="migration-modal-form">
              <EventFormContainer onSubmitOverride={onSubmitOverride} forMultipleEventsMigration />
              <div className="help-section">
                <div className="faq-link">
                  {(!createEventOverride && migrationEvents.orderedIds.length !== 0) ? (
                    <p>Not sure what to do? <a href="https://help.zola.com/hc/en-us/articles/360002649351-I-m-being-forced-to-pick-an-event-for-my-RSVP-s-Help-" target="_blank" rel="noreferrer noopener" className="text-button">Learn More &rsaquo;</a></p>
                  ) : (
                    <p>Not sure what to do? <a href="https://help.zola.com/hc/en-us/articles/360002649491-Why-an-I-being-forced-to-create-an-event-" target="_blank" rel="noreferrer noopener" className="text-button">Learn More &rsaquo;</a></p>
                  )}
                </div>
                <div className="help-text">
                  <p>Need our help? Email <a href="mailto:support@zola.com">support@zola.com</a> or call us at 408-657-ZOLA.</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

MultipleEventsMigrationModal.propTypes = {
  migrationEvents: PropTypes.shape({
    byId: PropTypes.shape({}),
    orderedIds: PropTypes.arrayOf(PropTypes.number)
  }).isRequired,
  onMigrateWeddingAccount: PropTypes.func,
  onSubmitOverride: PropTypes.func,
};

const mapStateToProps = state => ({
  migrationEvents: state.events.migration
});

const mapDispatchToProps = dispatch => ({
  onMigrateWeddingAccount: (eventId) => { // eslint-disable-line
    return dispatch(migrateWeddingAccount(eventId))
      .then(() => dispatch(fetchDashboard()))
      .then(() => dispatch(hideModal()))
      .then(() => setCookie('hideMultipleEventsModal', true, 180));
  },
  onSubmitOverride: (request) => { // eslint-disable-line
    return dispatch(createEventAndMigrate(request))
      .then(() => dispatch(fetchDashboard()))
      .then(() => dispatch(hideModal()))
      .then(() => setCookie('hideMultipleEventsModal', true, 180));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultipleEventsMigrationModal);



// WEBPACK FOOTER //
// ./src/components/common/modals/MultipleEventsMigrationModal/MultipleEventsMigrationModal.jsx